// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1wfAl","noInteraction":"EventWrapper_noInteraction__118YX","pointerPassthrough":"EventWrapper_pointerPassthrough__JdkkK"};